const AMPLITUDE_SCRIPT_URL = "https://cdn.amplitude.com/script/e5f467d7c370a3f4eeac25978c951f25.js";

let initialized = false;

interface AmplitudeInstance {
    add: (plugin: unknown) => void;
    setUserId: (id: string) => void;
}

interface SessionReplay {
    plugin: (config: { sampleRate: number }) => unknown;
}

declare global {
    interface Window {
        amplitude?: AmplitudeInstance;
        sessionReplay?: SessionReplay;
    }
}

export function initAmplitude(userId: string): void {
    if (initialized) {
        return;
    }

    const script = document.createElement("script");
    script.src = AMPLITUDE_SCRIPT_URL;
    script.onload = () => {
        if (window.amplitude && window.sessionReplay) {
            window.amplitude.add(window.sessionReplay.plugin({ sampleRate: 1 }));
            window.amplitude.setUserId(userId);
        }
    };
    document.head.appendChild(script);
    initialized = true;
}
